import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import integration from 'common/javascript/integration'
import tools from 'common/javascript/tools/tools'
import vfilter from 'common/javascript/vfilter'
import * as filters from './filters'
import store from './store'
import 'common/sass/index.scss'
import hljs from 'highlight.js'
import 'highlight.js/styles/googlecode.css'
import VueI18n from 'vue-i18n'
import LangZhCn from 'common/i18n/zh-cn'
import LangEnUs from 'common/i18n/en-us'
import LangZhCt from 'common/i18n/zd-ct'
import { MY_ZETRIX_LOGO } from './common/config/enumeration/index'
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/icon.css'

// 添加vue整合
integration()
// 添加vueFilter
vfilter()

import {
  Input,
  Form,
  FormItem,
  Table,
  TableColumn,
  Pagination,
  Select,
  Option,
  Button,
  Tabs,
  TabPane,
  Tooltip,
  Dropdown,
  DropdownMenu,
  Card,
  Row,
  Col,
  Image,
  Tag,
  DropdownItem,
  Radio,
  RadioButton,
  RadioGroup,
  DatePicker,
  InputNumber,
  OptionGroup,
  Loading
} from 'element-ui'
import lang from 'element-ui/lib/locale/lang/en'
import localeEn from 'element-ui/lib/locale'
import VueMeta from 'vue-meta'

localeEn.use(lang)

// Override the default 'pagesize' label to remove '/ pages' text
lang.el.pagination.pagesize = ''  // Remove the '/ pages' text

Vue.use(Input)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Select)
Vue.use(Option)
Vue.use(Button)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Tooltip)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Tag)
Vue.use(Image)
Vue.use(VueI18n)
Vue.use(DatePicker)
Vue.use(Radio)
Vue.use(RadioButton)
Vue.use(RadioGroup)
Vue.use(InputNumber)
Vue.use(OptionGroup)
Vue.use(Loading.directive)
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

const i18n = new VueI18n({
  locale: tools.getLang(),
  messages: {
    'cn': LangZhCn,
    'en': LangEnUs,
    'ct': LangZhCt
  }
})
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
// vue bus
function vueBus (Vue) {
  var bus = new Vue()
  bus.data = {
    host: 'glob'
  }
  Object.defineProperty(Vue.prototype, '$bus', {
    get: function () {
      return bus
    }
  })
}
vueBus(Vue)
Vue.prototype.MY_ZETRIX_LOGO = MY_ZETRIX_LOGO
// 请求前拦截
// axios.interceptors.request.use((config) => {
//   return config
// }, (err) => {
//   return Promise.reject(err)
// })

// 响应拦截
axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
 // 处理响应失败
  return Promise.reject(error)
})

// 路由跳转前处理
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }

  const metaTags = to.meta.metaTags || []
  metaTags.forEach(tag => {
    const element = document.createElement('meta')
    Object.keys(tag).forEach(key => element.setAttribute(key, tag[key]))
    document.head.appendChild(element)
  })
  next()
})

// 路由跳转后处理
router.afterEach(route => {
  // console.log(route)
})
hljs.initHighlightingOnLoad()
Vue.directive('hljs', el => { // highlight code directive
  let blocks = el.querySelectorAll('pre code')
  Array.prototype.forEach.call(blocks, hljs.highlightBlock)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  i18n,
  router,
  template: '<App/>',
  components: { App },
  render: h => h(App)
}).$mount('#app')
